import "./layout.css";
import i from "./i.png";
import f from "./f.png";
import x from "./x.png";
import Header from "./Header/Header";

export const Layout = ({ children }) => {
  return (
    <>
      <header>
        <Header />
      </header>
      {children}
      <footer class="footer">
        <h2>Connect With Us</h2>
        <p>
          <strong>Ph:</strong>
          +919540205885
        </p>
        <p>
          <strong>Email:</strong> ramstartwork@gmail.com
        </p>
        <p>
          <strong>Office:</strong> No # 34, 7th Cross, 3rd Cross, Teachers
          Layout, 2nd Stage M S Palya, Vidyaranyapura, Bangalore-560097
        </p>
        {/* <div class="social-icons">
          <a href="#">
            <img src={f} alt="Facebook" />
          </a>
          <a href="#">
            <img src={x} alt="Twitter" />
          </a>
          <a href="#">
            <img src={i} alt="Instagram" />
          </a>
        </div> */}
      </footer>{" "}
    </>
  );
};
